import { createFileRoute } from '@tanstack/react-router';

import { EditCustomPartOfferPage as PartLibraryEditCustomPartOfferPage } from '@/areas/offers/CustomPartOfferForm/pages/EditCustomPartOfferPage';
import { canEditPartLibraryOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/components/ipn/offers/$offerId/edit')({
    staticData: { access: { permissions: canEditPartLibraryOffers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <PartLibraryEditCustomPartOfferPage {...pathParams} />;
}
